<template>
  <div>
    <tab-nav :tab-pane-list="tabPaneList" />
  </div>
</template>

<script>
import tabNav from '@/components/tab-nav.vue' // 评分量表
export default {
  components: {
    tabNav
  },
  data() {
    return {
      tabPaneList: [
        {
          id: '0',
          label: '查看数据',
          route: '/dataManage/noteZQList',
          pathGroup: [
            '/dataManage/noteZQList',
            '/dataManage/noteZQDetail'
          ]
        }, {
          id: '1',
          label: '导入数据',
          route: '/dataManage/noteZQImport'
        }, {
          id: '2',
          label: '千瓜数据导入',
          route: '/dataManage/noteMolonChatImport'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
</style>
